import { Mail, Phone } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSms } from "@fortawesome/free-solid-svg-icons";
import { Mover } from "@/types";

type PortalHeaderProps = {
  mover: Mover;
  className?: string;
};

export function PortalHeader({ mover, className = "" }: PortalHeaderProps) {
  return (
    <div className="w-full container mx-auto">
      <div
        className={`w-full flex flex-row justify-between items-start gap-4 md:gap-0 pb-4 ${className}`}
      >
        <div className="flex flex-col md:flex-row gap-3 justify-start items-start">
          <img src={`${mover.logo_url}`} alt="Logo" className="h-16" />
        </div>
        <div className="flex flex-col justify-start items-end text-right gap-1 text-black text-xs md:text-sm font-mono">
          <div className="font-semibold font-sans">We're here to help</div>
          <div className="flex flex-col items-end gap-1">
            <div className="flex flex-row items-center gap-1">
              <Phone className="w-3 h-3" />
              <div>
                <a href={`tel:${mover?.business_phone}`}>
                  {mover?.business_phone}
                </a>
              </div>
            </div>
            <div className="flex flex-row items-center gap-1">
              <FontAwesomeIcon icon={faSms} className="w-3 h-3" />
              <div>
                <a href={`sms://+18774524374`}>877-452-4374</a>
              </div>
            </div>
            <div className="flex flex-row items-center gap-1">
              <Mail className="w-3 h-3" />
              <div>
                <a href={`mailto:${mover.email}`}>{mover.email}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
